import { render, staticRenderFns } from "./CobranzaImportPage.vue?vue&type=template&id=4798ccd5&scoped=true"
import script from "./CobranzaImportPage.vue?vue&type=script&lang=js"
export * from "./CobranzaImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798ccd5",
  null
  
)

export default component.exports